import { Outlet, createRootRouteWithContext, redirect } from '@tanstack/react-router';
import { ToastProvider } from '@portal/ui';
import type { RouterContext } from '@/router';
import { legacyRedirect } from '@/legacy-redirects';
import { NotFound } from '@/components/not-found';

export const Route = createRootRouteWithContext<RouterContext>()({
  // Old addresses first, before anything matches (see src/legacy-redirects.ts).
  beforeLoad: ({ location }) => {
    const target = legacyRedirect(location.pathname, location.searchStr);
    if (target) {
      throw redirect({ href: target });
    }
  },
  component: RootComponent,
  notFoundComponent: NotFound,
});

/** Every page can raise a toast (`useToast()`), including the pre-login ones. */
function RootComponent() {
  return (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  );
}
